export var Roles;
(function (Roles) {
    Roles["Admin"] = "Admin";
    // Features
    Roles["Workflows"] = "Feature-Workflows";
    Roles["Quotes"] = "Feature-Quotes";
    Roles["AICall"] = "Feature-AICall";
})(Roles || (Roles = {}));
//# sourceMappingURL=roles.js.map